import { useTranslation } from 'react-i18next';
import { Col, Icon, Row, Text, useFormatMembersCount } from 'ui';

type P = { count: number };

const GiversCount = ({ count }: P) => {
  const { t } = useTranslation();
  const formattedParticipantsCount = useFormatMembersCount({ count });

  return (
    <Row gutter={['xxs', 0]}>
      <Col>
        <Icon icon="group-line" size="extra-small" />
      </Col>
      <Col>
        <Text>{t('formattedDonorsCount', { count, formattedCount: formattedParticipantsCount })}</Text>
      </Col>
    </Row>
  );
};

export default GiversCount;
